<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M1.57178 1.5L16.5718 16.5" stroke="#21242C" stroke-width="2.1" stroke-linejoin="round" />
    <path d="M1.57178 16.5L16.5718 1.5" stroke="#21242C" stroke-width="2.1" stroke-linejoin="round" />
  </svg>
</template>
